import React from 'react'
import {
  FilterTable,
  Accordion
} from 'camino-react'
import _ from 'lodash'
import moment from 'moment-timezone'

import DescriptionPopup from '../../PopupWrapper/DescriptionPopup'

const tasksTableColumns = [
  {
    text: 'ID',
    accessor: 'id',
    defaultWidth: '100',
    maxWidth: '150'
  },
  {
    text: 'Task Name',
    accessor: 'name',
    defaultWidth: '100'
  },
  {
    text: 'Description',
    accessor: 'description',
    defaultWidth: '50',
    Cell: row => (<DescriptionPopup row={row} />)
  },
  {
    text: 'Ticket ID',
    accessor: 'ticket_id',
    defaultWidth: '100',
    maxWidth: '150',
    Cell: row => (
      <a href={`/tickets/${row.original.ticket_id}`} target="_blank" rel="noopener noreferrer">#{row.original.ticket_id}</a>
    )
  },
  {
    text: 'Ticket title',
    accessor: 'ticket_name',
    defaultWidth: '100'
  },
  {
    text: 'Ticket client',
    accessor: 'ticket_client',
    defaultWidth: '100'
  },
  {
    text: 'Assignee',
    accessor: 'assignee_name',
    defaultWidth: '100'
  },
  {
    text: 'Completer',
    accessor: 'completer_name',
    defaultWidth: '100'
  },
  {
    text: 'Estimation Time',
    accessor: 'estimation_time',
    defaultWidth: '100'
  },
  {
    accessor: 'created_at',
    text: 'Created at',
    defaultWidth: '50',
    maxWidth: '130',
    Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA'))
  },
  {
    accessor: 'due_at',
    text: 'Due at',
    defaultWidth: '50',
    maxWidth: '130',
    Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA'))
  },
  {
    accessor: 'completed_at',
    text: 'Completed at',
    defaultWidth: '50',
    maxWidth: '130',
    Cell: row => (row.value ? moment(row.value).format('DD MMM YYYY, hh:mmA') : 'Not yet completed')
  }
]

const Table = ({ data }) => (<FilterTable data={data} columns={tasksTableColumns} />)

const Report = ({ filters: { group_by, display_all_tasks }, tasks, needToFilter }) => {
  if (display_all_tasks && !needToFilter) {
    return (
      <Table data={tasks} />
    )
  }

  if (needToFilter) {
    return (
      <div>Click Filter button to display filtered tasks.</div>
    )
  }

  return (
    <div>
      <Accordion>
        {
          _.map(tasks, (value, title) => ({
            title,
            subTitle: (<><strong>{value.length}</strong>{' '} tasks</>),
            content: (<Table data={value} />)
          }))
        }
      </Accordion>
    </div>
  )
}

export default Report
